import {gql} from '@apollo/client';

const FIELDS = `
    arcimedes_row_id
    property_id
    county
    current_tax_appraised_value
    mill_rate
    new_assessed_value
    google_maps_link
    cad_link
    analysis_date
    cap_rate
    bps_change
    down_payment_percent
    interest_rate
    amortization
    management_fee_percent
    proforma_management_fee_percent
    insurance
    proforma_insurance
    utilities
    proforma_utilities
    repairs_maintenance
    proforma_repairs_maintenance
    payroll
    proforma_payroll
    general_administrative
    proforma_general_administrative
    contract_services
    proforma_contract_services
    marketing
    proforma_marketing
    expense_notes
    vacancy
    proforma_vacancy
    non_revenue_units
    proforma_non_revenue_units
    loss_to_lease
    proforma_loss_to_lease
    rent_concessions
    proforma_rent_concessions
    bad_debt
    proforma_bad_debt
    unit_mix { floor_plan units avg_sf rent proforma_rent occupied_units }
    current_other_income { category amount }
    proforma_other_income { category amount }
    arcimedes_modified
`;

export const GET_UNDERWRITING_MULTI_FAMILY = gql`
    query GetUnderwritingMultiFamily($propertyId: ID!) {
        getUnderwritingMultiFamily(property_id: $propertyId) {
            ${FIELDS}
        }
    }
`;

export const SAVE_UNDERWRITING_MULTI_FAMILY = gql`
    mutation CreateOrUpdateUnderwritingMultiFamily($input: UnderwritingMultiFamilyInput!) {
        createOrUpdateUnderwritingMultiFamily(input: $input) {
            success
            message
            error
            underwritingMultiFamily {
                ${FIELDS}
            }
        }
    }
`;
